import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { BRAND } from "@/data/site";
import { EASE } from "@/components/blocks";

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
            "Hi StrengthLeap — I'd like to know more about live 1:1 coaching."
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-fab"
          aria-label="Chat with StrengthLeap on WhatsApp"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.45, ease: EASE }}
          className="group fixed bottom-6 right-6 z-40 flex items-center gap-0 bg-lime py-3.5 pl-4 pr-4 text-white shadow-[0_8px_32px_rgba(37,99,235,0.45)] transition-colors duration-300 hover:bg-limed sm:bottom-8 sm:right-8"
        >
          <MessageCircle className="h-5 w-5 shrink-0" />
          <span className="max-w-0 overflow-hidden whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.22em] opacity-0 transition-all duration-300 group-hover:ml-3 group-hover:max-w-[200px] group-hover:opacity-100">
            Chat on WhatsApp
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
